const Phone = ({ color = "var(--grey400)" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
    >
      <path
        d="M7.66671 0.666016H2.33337C1.80294 0.666016 1.29423 0.876729 0.919161 1.2518C0.544088 1.62687 0.333374 2.13558 0.333374 2.66602V13.3327C0.333374 13.8631 0.544088 14.3718 0.919161 14.7469C1.29423 15.122 1.80294 15.3327 2.33337 15.3327H7.66671C8.19714 15.3327 8.70585 15.122 9.08092 14.7469C9.45599 14.3718 9.66671 13.8631 9.66671 13.3327V2.66602C9.66671 2.13558 9.45599 1.62687 9.08092 1.2518C8.70585 0.876729 8.19714 0.666016 7.66671 0.666016ZM8.33337 13.3327C8.33337 13.5095 8.26314 13.6791 8.13811 13.8041C8.01309 13.9291 7.84352 13.9993 7.66671 13.9993H2.33337C2.15656 13.9993 1.98699 13.9291 1.86197 13.8041C1.73695 13.6791 1.66671 13.5095 1.66671 13.3327V2.66602C1.66671 2.4892 1.73695 2.31964 1.86197 2.19461C1.98699 2.06959 2.15656 1.99935 2.33337 1.99935H7.66671C7.84352 1.99935 8.01309 2.06959 8.13811 2.19461C8.26314 2.31964 8.33337 2.4892 8.33337 2.66602V13.3327Z"
        fill={color}
      />
      <circle cx="4.90006" cy="12.566" r="0.9" fill={color} />
    </svg>
  );
};

export default Phone;
